import { render, staticRenderFns } from "./BizTaskModule.vue?vue&type=template&id=2a610be2&scoped=true&"
import script from "./BizTaskModule.vue?vue&type=script&lang=js&"
export * from "./BizTaskModule.vue?vue&type=script&lang=js&"
import style0 from "./BizTaskModule.vue?vue&type=style&index=0&id=2a610be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a610be2",
  null
  
)

export default component.exports